const timeout = 5000;

const alertElements = document.querySelectorAll('.site__flashes .alert-dismissible');

alertElements.forEach((element, index) => {
    setTimeout(() => {
        element.remove();
    }, (index + 1) * timeout);
});
